import { formatDateTimeIso, formatDayMonth } from "../../app/units/format";
import type { UnitsSettings } from "../../app/units/units";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const DAY_KEY: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit" };

export type DashboardListDateParts = { date: string | null; time: string | null };

/**
 * Datumsspalte aller Dashboard-Listen (Ronny, 14.10.2026): heute nur die Uhrzeit, sonst Tag und Monat
 * ohne Jahr — die Listen reichen nie so weit, dass das Jahr unklar wäre. Reine Datumswerte
 * (`YYYY-MM-DD`, z. B. Geburtstage) zeigen immer nur Tag und Monat.
 */
export function dashboardListDateParts(value: string | null | undefined, units: UnitsSettings | undefined, withTime = true, now = new Date()): DashboardListDateParts {
  const raw = String(value ?? "").trim();
  if (!raw) return { date: null, time: null };
  if (DATE_ONLY.test(raw)) return { date: formatDayMonth(raw, units) || null, time: null };
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return { date: null, time: null };
  const time = withTime ? formatDateTimeIso(raw, units, { hour: "2-digit", minute: "2-digit" }) : null;
  const today = formatDateTimeIso(now.toISOString(), units, DAY_KEY) === formatDateTimeIso(raw, units, DAY_KEY);
  if (today && time) return { date: null, time };
  return { date: formatDateTimeIso(raw, units, { day: "2-digit", month: "2-digit" }), time };
}
